import { UserOutlined } from '@ant-design/icons-vue';
import { AUTH_KEYS } from '@/constants';
import Layout from '@/layout/Layout.vue';

export default {
  path: '/license-management',
  component: Layout,
  name: 'LicenseManagementParent',
  meta: { title: 'license_management', root: true, auth: AUTH_KEYS.LICENSE_MANAGEMENT },
  children: [
    {
      path: '/license-management',
      name: 'LicenseManagement',
      component: () => import('@/views/LicenseManagement/LicenseManagement.vue'),
      meta: { title: 'License Management', isHide: true }
    }
  ]
};
